/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

import PlansApi from "../../api/PlansApi";
import PriceDisplay from "../../components/PriceDisplay";
import { PricingPlanCard } from "../../components/cards";
import { appConstants } from "../../config/app-constants";
import { EToastvariant, IPlansRoot } from "../../config/interfaces";
import { useAppDispatch } from "../../redux/Store";
import { getFilingDetails } from "../../redux/slice/ITRFilingSlice";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../services";

type Props = {};

const PublicPricingPlans: React.FC<Props> = (props: Props) => {
  const { filingUUID } = useParams();
  const dispatch = useAppDispatch();

  const [PublicPricingPlans, setPublicPricingPlans] = useState<IPlansRoot[]>([]);

  useEffect(() => {
    getPublicPricingPlans();
  }, []);

  useEffect(() => {
    if (filingUUID) {
      dispatch(getFilingDetails(filingUUID));
    }
  }, [filingUUID]);

  const getPublicPricingPlans = async () => {
    try {
      const plansApi = PlansApi.getInstance();
      const { records } = await plansApi.getPublicPlans({
        offset: 0,
        count: -1,
        orderBy: "createdAt",
        order: "ASC",
        type: "assisted"
      });

      const sortedRecords = records.sort((p1: any, p2: any) => {
        if (Number(p1.pricingTitle) < Number(p2.pricingTitle)) return -1;
        if (Number(p1.pricingTitle) > Number(p2.pricingTitle)) return 1;
        return 0;
      });

      setPublicPricingPlans(() => sortedRecords);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  // send Plans container height after 2 seconds
  useEffect(() => {
    setTimeout(() => {
      const _documentHeight: number =
        document.getElementById("public-plans-wrap")?.clientHeight || 0;
      sendMessageUpdatingHeight(_documentHeight);
    }, 2000);
  }, []);

  // sending Plans container height to Iframe
  const sendMessageUpdatingHeight = (height: number) => {
    window.parent.postMessage({ eventName: "SET_PLANS_HEIGHT", payload: { height } }, "*");
  };

  return (
    <Container className="w-1170" id="public-plans-wrap">
      <div className="my-5 text-center">
        <h2 className="fw-bold">
          Choose Tailored Plans <span className="d-block text-primary">for Your ITR Filing</span>
        </h2>
      </div>

      <PricingPlanCard
        pricingPlans={PublicPricingPlans}
        handlePlanSelect={(plan) => {
          window.open(`${appConstants.portalUrl}/itr-filings/assisted/${plan.uuid}`, "_blank");
        }}
        isProcessing={false}
      />

      <div className="plan-page-footer text-center my-5">
        <h5 className="mb-0">
          <em>
            *For Balance sheet & P/L / Attestation: <PriceDisplay price={1000} decimalUpto={0} />
          </em>
        </h5>
        <h5>
          <em>*18% GST will be applicable to the base plan amount</em>
        </h5>
      </div>
    </Container>
  );
};

export default PublicPricingPlans;
